export default {
  hideCategoryInfoOnNavigationType: ['big', 'embed'],
};
